import React, { useState } from 'react';

interface AccordionItemProps {
	askViewYn?: string;
	expertAskType?: string;
	expertAskTitle?: string;
	expertAskCtnt?: string;
	expertRplyCtnt?: string;
	expertAskId?: string;
}

interface AccordionProps {
	items: Omit<AccordionItemProps, 'isFaq'>[];
	isFaq?: boolean;
}

const AccordionItem = ({ expertAskTitle, expertAskCtnt, expertRplyCtnt, askViewYn }: AccordionItemProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleAccordion = () => {
		setIsOpen(!isOpen);
	};

	return (
		<>
			<div
				className={`accordion-title ${isOpen ? 'open' : ''}`}
				onClick={askViewYn === 'N' ? undefined : toggleAccordion}>
				<p>{expertAskTitle}</p>

				{askViewYn === 'N' ? (
					<i className="accordion-icon locked" />
				) : (
					<i className={`accordion-icon ${isOpen ? 'open' : ''}`} />
				)}
			</div>

			<div className={`accordion-item ${!isOpen || askViewYn === 'N' ? 'collapsed' : ''}`}>
				<div className="accordion-content">
					<div className="content-box">
						<div className="ask-content">
							{expertAskCtnt?.split(/\r\n|\n/).map((line, index) => (
								<React.Fragment key={index}>
									{line}
									<br />
								</React.Fragment>
							))}
						</div>
						{expertRplyCtnt ? (
							<div className="reply-content">
								{expertRplyCtnt
									?.split(/\r\n|\n/)
									.map((line, index) => <div key={index} dangerouslySetInnerHTML={{ __html: line }} />)}
							</div>
						) : (
							''
						)}
					</div>
				</div>
			</div>
		</>
	);
};

const Accordion = ({ items, isFaq }: AccordionProps) => {
	return (
		<div className={`accordion ${isFaq ? 'faq' : ''}`}>
			{items.map((item, index) => (
				<AccordionItem
					key={`${item.expertAskType}_${index}`}
					expertAskTitle={item.expertAskTitle}
					expertAskCtnt={item.expertAskCtnt}
					expertRplyCtnt={item.expertRplyCtnt}
					askViewYn={item.askViewYn}
				/>
			))}
		</div>
	);
};

export default Accordion;
